<template>
  <div class="smart-point-default">
    <GenericModal
      :unique-id="`smartPointModal${getSelectedTransporterClassName}`"
      :ref="`smartPointModal${getSelectedTransporterClassName}`"
      :has-header="false"
      :has-footer="false"
      :close-dispatch-event="'smartPointMapCloseEvent'"
      :open-dispatch-event="'smartPointMapOpenEvent'"
      :close-btn-color="'#ef1b1b'"
    >
      <SmartPointMap
        smart-points-getter="getSelectedTransporterSmartPoints"
        :use-clusters="true"
      >
      </SmartPointMap>
    </GenericModal>
    <template>
      <div v-if="shouldEnableSmartPointSelection(transporter.class_name)">
        <SmartPointSelection></SmartPointSelection>
      </div>
      <div v-if="transporterSmartPointsApiError(transporter)" class="smart-point-api-error">
        <span v-html="transporterSmartPointsApiErrorMessage(transporter)" class="smart-point-api-error-text"></span>
      </div>
      <div v-if="getSelectedSmartPoint && (shouldEnableSmartPointSelection(transporter.class_name) || shouldEnableSmartPointSelectionWidget(transporter.class_name))" class="smart-point-selected">
          <span class="smart-point-selected-text" @click="smartPointClickEvent()">
            {{ t('checkout.transporters.smart_point.selected.locker') }}
            <span class="smart-point-selected-text-point_name">
              {{ getSelectedSmartPoint.name }}
            </span>
          </span>
      </div>
    </template>
  </div>
</template>

<script>
import SmartPointSelection from './SmartPointSelection.vue'
import SmartPointMap from './SmartPointMap.vue'
import GenericModal from '../presentation/GenericModal.vue'
import SmartPointMixin from './SmartPointMixin'

export default {
  name: 'SmartPointDefault',
  mixins: [SmartPointMixin],
  props: {
    transporter: {
      type: Object,
      required: true
    }
  },
  components: {
    SmartPointSelection,
    SmartPointMap,
    GenericModal
  },
  created () {
    this.$root.$on('smartPointClickEvent', () => {
      const modal = this.$refs[`smartPointModal${this.getSelectedTransporterClassName}`]
      if (!modal) {
        return
      }
      modal.openModal()
    })
  },
  destroyed () {
    this.$root.$off('smartPointClickEvent')
  }
}
</script>
